import { Form, Select, Divider, Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";

const SelectCustomer = ({
  form,
  customerLoading,
  customerOptions,
  onAddNewCustomer,
  searchValue,
  onSearchChange,
}) => {
  return (
    <div>
      <Form form={form} layout="vertical">
        <Form.Item
          label="Choose Customer"
          name="customer"
          rules={[{ required: true, message: "Please select a customer" }]}
        >
          <Select
            placeholder="Select Customer"
            size="large"
            loading={customerLoading}
            options={customerOptions}
            showSearch
            searchValue={searchValue}
            onSearch={onSearchChange}
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            dropdownRender={(menu) => (
              <>
                {menu}
                <Divider style={{ margin: "4px 0" }} />
                <Button
                  type="text"
                  block
                  icon={<PlusOutlined />}
                  onClick={onAddNewCustomer}
                  className="text-left"
                >
                  Add new customer
                </Button>
              </>
            )}
          />
        </Form.Item>
      </Form>
    </div>
  );
};
export default SelectCustomer;
